import { render, staticRenderFns } from "./RequestStory.vue?vue&type=template&id=006964fa&"
import script from "./RequestStory.vue?vue&type=script&lang=js&"
export * from "./RequestStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports